import React, { useState } from "react";
import MenuOptions from "./MenuOption";
import { List } from "@material-ui/core";
import { DrawerSidebar } from "../../components/DrawerSidebar";
import { useStyles } from "./AdminStyles";

const MenuBar = (props) => {
  const { open, setOpen, menuItems, currentSelected, setCurrentSelected } = props
  const width = 240
  return (
    <DrawerSidebar open={open} setOpen={setOpen} width={width} >
      <List>
        {menuItems.map((item) => (
          <MenuOptions
            key={item.id}
            item={item}
            active={item.id === currentSelected.id}
            onClick={() => {
              setCurrentSelected(item)
              setOpen()
            }
            }
          />
        ))}
      </List>

    </DrawerSidebar>
  );
};

export default MenuBar;
